export enum QueryKeys {
  GetAllActivitiesByRecordId = 'get-all-activities-by-record-id',
}
